<template>
  <div class="page-changeCity">
    <el-row>
      <province />
    </el-row>
    <el-row>
      <HotCity title="热门城市:" :list="hotList" />
    </el-row>
    <el-row>
      <HotCity title="最近访问:" :list="rencentList" />
    </el-row>
    <el-row>
      <Category />
    </el-row>
  </div>
</template>

<script>
import Province from "@/components/changeCity/Province.vue";
import HotCity from "@/components/changeCity/HotCity.vue";
import Category from "@/components/changeCity/Category.vue";
import api from "@/api/index.js";
export default {
  components: {
    Province,
    HotCity,
    Category,
  },
  data() {
    return {
      hotList: [],
      rencentList: [],
    };
  },
  created() {
    api.getHotCity().then((res) => {
      this.hotList = res.data.data.map((item) => item.name);
    });
    api.getRecentCity().then((res) => {
      this.rencentList = res.data.data.map((item) => item.name);
    });
  },
};
</script>
